const SCRIPT_ID = "jira-script-tag";
const WIDGET_ID = "jsd-widget";

export const createWidget = (key) => {
    if (!key) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const jiraScriptTag = document.createElement("script");
    jiraScriptTag.id = SCRIPT_ID;
    jiraScriptTag.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
    jiraScriptTag.setAttribute("data-jsd-embedded", true);
    jiraScriptTag.setAttribute("data-key", key);
    jiraScriptTag.src = "https://jsd-widget.atlassian.com/assets/embed.js";
    document.body.appendChild(jiraScriptTag);
    setTimeout(() => {
        window.document.dispatchEvent(
            new Event("DOMContentLoaded", { bubbles: true, cancelable: true })
        );
        const widget = document.getElementById(WIDGET_ID);
        if (widget) widget.style.top = "0px";
    }, 1000);
}

export const destroyWidget = () => {
    const script = document.getElementById(SCRIPT_ID);
    if (script && script.parentNode) script.parentNode.removeChild(script);
    const widget = document.getElementById(WIDGET_ID);
    if (widget && widget.parentNode) widget.parentNode.removeChild(widget);
}